<template>
  <div class="stc" dir="rtl">
    <span class="stc-tile" :class="`stc-tile--${view.tone}`">
      <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <template v-if="view.icon === 'target-arrow'">
          <path d="M21 12a9 9 0 1 1-9-9" />
          <path d="M17 12a5 5 0 1 1-5-5" />
          <circle cx="12" cy="12" r="1.2" fill="currentColor" />
          <path d="M13 11l7-7M17 4h3v3" />
        </template>
        <template v-else-if="view.icon === 'target'">
          <circle cx="12" cy="12" r="9" />
          <circle cx="12" cy="12" r="4" fill="currentColor" />
        </template>
        <template v-else-if="view.icon === 'trend-up'">
          <path d="M3 17l6-6 4 4 8-8" />
          <path d="M15 7h6v6" />
        </template>
        <template v-else-if="view.icon === 'trend-down'">
          <path d="M3 7l6 6 4-4 8 8" />
          <path d="M15 17h6v-6" />
        </template>
        <template v-else-if="view.icon === 'shield'">
          <path d="M12 3l8 3v6c0 4.5-3.2 7.8-8 9-4.8-1.2-8-4.5-8-9V6l8-3z" />
          <path d="M9 12l2 2 4-4" />
        </template>
        <template v-else-if="view.icon === 'hand'">
          <path d="M8 12V6a1.5 1.5 0 0 1 3 0v5m0-1V4.5a1.5 1.5 0 0 1 3 0V11m0-4a1.5 1.5 0 0 1 3 0v6c0 4-2.5 7-6 7-2.5 0-4-1.5-5-3.5L4 13a1.5 1.5 0 0 1 2.5-1.5L8 13" />
        </template>
        <template v-else-if="view.icon === 'pause'">
          <path d="M9 6v12M15 6v12" />
        </template>
        <template v-else-if="view.icon === 'lock'">
          <rect x="5" y="11" width="14" height="9" rx="2" />
          <path d="M8 11V8a4 4 0 0 1 8 0v3" />
        </template>
        <template v-else>
          <circle cx="12" cy="12" r="9" />
          <path d="M5.6 5.6l12.8 12.8" />
        </template>
      </svg>
    </span>

    <span class="stc-text">
      <span class="stc-title">
        {{ view.title }}
        <i v-if="view.dot" class="stc-dot" />
      </span>
      <span v-if="view.subtitle" class="stc-sub">{{ view.subtitle }}</span>
    </span>
  </div>
</template>

<script>
export default {
  props: ['resourceName', 'field'],

  computed: {
    view() {
      const map = this.field.statuses || {}

      return (
        map[this.field.value] || { tone: 'gray', icon: 'ban', title: String(this.field.value ?? '—'), subtitle: '' }
      )
    },
  },
}
</script>

<style>
.stc {
  display: flex;
  gap: 12px;
  align-items: center;
  min-width: 190px;
}

.stc-tile {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
}

.stc-tile--blue { background: #e3effe; color: #2f6df6; }
.stc-tile--yellow { background: #fdf0c4; color: #d99a06; }
.stc-tile--gray { background: #eceef3; color: #6b7280; }
.stc-tile--green { background: #dcf5e4; color: #16a34a; }
.stc-tile--red { background: #fde4e4; color: #dc2626; }
.stc-tile--teal { background: #d5f4ef; color: #0d9488; }
.stc-tile--purple { background: #ece6fd; color: #7c3aed; }
.stc-tile--orange { background: #ffe9d6; color: #ea580c; }

.stc-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.stc-title {
  display: inline-flex;
  gap: 6px;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  color: #1f2937;
}

.stc-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 9999px;
  background: #e0a106;
}

.stc-sub {
  font-size: 13px;
  line-height: 20px;
  color: #8a91a5;
}

html.dark .stc-title { color: #f4f4f5; }
html.dark .stc-sub { color: #a1a1aa; }
html.dark .stc-tile--blue { background: rgba(59, 130, 246, 0.2); color: #93c5fd; }
html.dark .stc-tile--yellow { background: rgba(234, 179, 8, 0.2); color: #facc15; }
html.dark .stc-tile--gray { background: rgba(255, 255, 255, 0.08); color: #a1a1aa; }
html.dark .stc-tile--green { background: rgba(34, 197, 94, 0.2); color: #86efac; }
html.dark .stc-tile--red { background: rgba(239, 68, 68, 0.2); color: #fca5a5; }
html.dark .stc-tile--teal { background: rgba(20, 184, 166, 0.2); color: #5eead4; }
html.dark .stc-tile--purple { background: rgba(139, 92, 246, 0.2); color: #c4b5fd; }
html.dark .stc-tile--orange { background: rgba(249, 115, 22, 0.2); color: #fdba74; }
</style>
